import { render, staticRenderFns } from "./visitAdd.vue?vue&type=template&id=4e2d3744&scoped=true"
import script from "./visitAdd.vue?vue&type=script&lang=js"
export * from "./visitAdd.vue?vue&type=script&lang=js"
import style0 from "./visitAdd.vue?vue&type=style&index=0&id=4e2d3744&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d3744",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e2d3744')) {
      api.createRecord('4e2d3744', component.options)
    } else {
      api.reload('4e2d3744', component.options)
    }
    module.hot.accept("./visitAdd.vue?vue&type=template&id=4e2d3744&scoped=true", function () {
      api.rerender('4e2d3744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/visitRecords/visitAdd.vue"
export default component.exports